/**
 * @Note This function will check if the string is more than a certain length then after that it will slice it to that length
 * @param str 
 * @returns sliced string or original string
 */

export default function sliceToCertainLength (str,len) {
    return str?.length>len ? str?.slice(0,len) + "..." : str
}